
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactSection from './components/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <ContactHero />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default ContactPage;
